import { render, staticRenderFns } from "./insResult.vue?vue&type=template&id=98e33170"
import script from "./insResult.vue?vue&type=script&lang=js"
export * from "./insResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports